export const selectionWithItemSingular = "MXtzb";
export const selectionWithItemsFirstPlural = "ajLHwc";
export const selectionWithItemsSecondPlural = "AIehbd";
export const selectionWithConversationSingular = "KSJolb";
export const selectionWithConversationsFirstPlural = "O1gAzb";
export const selectionWithConversationsSecondPlural = "Sp6ABd";
export default {selectionWithItemSingular,selectionWithItemsFirstPlural,selectionWithItemsSecondPlural,selectionWithConversationSingular,selectionWithConversationsFirstPlural,selectionWithConversationsSecondPlural};